export default "__VITE_ASSET__BkKmhwz7__"